import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { InternalStatusLookup } from '../../api/models';

export type TABLE_TYPE = Table<InternalStatusLookup>;

export const TABLE = 'internalStatusLookups';
const SCHEMA = 'playerInternalStatusLookupId, sortId';

class InternalStatusLookupsDatabase implements DataRepository<InternalStatusLookup> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<InternalStatusLookup | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: InternalStatusLookup, key: Key): Promise<InternalStatusLookup> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: InternalStatusLookup[]): Promise<InternalStatusLookup[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<InternalStatusLookup[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const InternalStatusLookupsDB = new InternalStatusLookupsDatabase(db);
